const assetUrl = "https://data.pavelpo.cz/pracejakonakostele";
export const referenceUrl = `${assetUrl}/reference`;
export const priceListUrl = `${assetUrl}/priceList`;
export const galleryUrl = `${assetUrl}/gallery`;
export const galleryPreviewUrl = `${assetUrl}/gallery/preview`;
